export {
  AuthenticatedPageLayout,
  type AuthenticatedPageLayoutProps,
} from "./authenticated-page-layout"
